<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            Pembayaran
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="!$isEmpty(order.payment_log)" cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="col-square mb-4">
          <div class="content-square">
            <img :src="order.payment_log.qr_image" alt="" class="image-qris">
          </div>
        </div>
        <v-btn :href="order.payment_log.qr_image" download="QRIS.png" block color="primary" height="40" class="text-none br-8">
          <v-icon left>
            mdi-download
          </v-icon>
          Download QRIS
        </v-btn>
        <div class="qris-countdown mt-4">
          <div class="qris-countdown-icon">
            <img src="@/assets/images/warning_icon.png" alt="">
          </div>
          <div class="qris-countdown-content">
            <div class="qris-countdown-title">
              Segera bayar pesanan dalam {{ formattedTimeLeft }} menit.
            </div>
          </div>
        </div>
        <div v-if="!order.is_paid && order.status !== 'X' && !$isEmpty(order.payment_log) && order.payment_log.payment_source === 'ASTRAPAY-QRIS'" class="mt-4">
          <v-btn large block color="primary" class="text-none letter-spacing-normal font-weight-bold br-8" @click="checkStatusPayment()">
            Cek status pembayaran
          </v-btn>
        </div>
        <div class="qris-store-detail col-with-image mt-4">
          <div class="qris-store-detail-image col-with-image-icon">
            <img :src="$store.state.selected_outlet.logo" alt="">
          </div>
          <div class="col-with-image-content">
            <div class="col-with-image-title qris-store-detail-title">
              {{ order.store_name }}
            </div>
            <div v-mask-money="order.total_amount" class="col-with-image-subtitle qris-store-detail-subtitle" />
          </div>
        </div>
        <div class="col-with-image qris-order-detail mt-4 pa-4">
          <div class="col-with-image-content">
            <div class="col-with-image-subtitle">
              Order number
            </div>
            <div class="col-with-image-title">
              {{ order.order_no }}
            </div>
          </div>
          <div v-if="order.remark === 'OL-DINE-IN'" class="col-image-icon-table">
            <div class="d-flex align-center">
              <div class="mr-1">
                <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-table-icon">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.99822 0.166656C1.34659 0.166656 0.790427 0.637646 0.683096 1.28037L0.349109 3.28037C0.21337 4.09321 0.840144 4.83332 1.66423 4.83332H2.71394V10.3426C2.71394 10.6136 2.93364 10.8333 3.20466 10.8333C3.44979 10.8333 3.65733 10.6524 3.69078 10.4096L4.09164 7.49999H9.90857L10.3094 10.4096C10.3429 10.6524 10.5504 10.8333 10.7956 10.8333C11.0666 10.8333 11.2863 10.6136 11.2863 10.3426V4.83332H12.336C13.1601 4.83332 13.7868 4.09321 13.6511 3.28037L13.3171 1.28037C13.2098 0.637647 12.6536 0.166656 12.002 0.166656H1.99822ZM9.72488 6.16666L9.55372 4.92431C9.5495 4.89368 9.54743 4.8633 9.54737 4.83332H4.45284C4.45278 4.8633 4.45071 4.89368 4.44649 4.92431L4.27533 6.16666H9.72488ZM1.99822 1.49999L12.002 1.49999L12.336 3.49999L1.66423 3.49999L1.99822 1.49999Z" fill="#272727" />
                </svg>
              </div>
              <div class="col-image-icon-table-text">
                Meja {{ order.table_no }}
              </div>
            </div>
          </div>
        </div>
        <div class="qris-quide mt-4">
          <div class="qris-guide-title">
            Cara bayar dengan QRIS
          </div>
          <div>
            <ol class="qris-guide-list">
              <li>
                Tekan tombol "Download QRIS" untuk mengunduh gambar QRIS.
              </li>
              <li>
                Buka aplikasi e-Wallet atau e-Banking. yang menyediakan pembayaran QRIS.
              </li>
              <li>
                Cari opsi scan QRIS dari gambar. Pilih gambar QRIS yang sebelumnya di download.
              </li>
              <li>
                Setelah discan, maka akan muncul total harga transaksi.
              </li>
              <li>
                Konfirmasi dan bayar.
              </li>
              <li>
                Anda berhasil membayar pesanan.
              </li>
            </ol>
          </div>
        </div>
        <v-btn block height="40" color="#0078CE" class="white--text text-none mt-4 font-weight-bold br-5" @click="goToOrder(order.id)">
          {{ $t('order_detail') }}
        </v-btn>
        <v-btn block height="40" color="white" class="text-none mt-2 font-weight-bold br-5" @click="goHome()">
          {{ $t('back_to_menu') }}
        </v-btn>
        <v-btn block height="40" color="white" class="error--text text-none mt-2 font-weight-bold br-5" @click="confirmCancel()">
          {{ $t('cancel_order') }}
        </v-btn>
        <v-dialog v-model="dialog.dialogCancelOrder" max-width="290">
          <v-card>
            <v-card-title class="headline">
              Konfirmasi
            </v-card-title>
            <v-card-text>
              Apakah Anda yakin ingin membatalkan pesanan?
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="grey" text @click="dialog.dialogCancelOrder = false">
                No
              </v-btn>
              <v-btn color="primary" outlined @click="cancelOrder(order.id)">
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="dataSuccess.show" multi-line top color="success" :timeout="3000">
          {{ dataSuccess.message }}
          <v-btn class="transparent" text fab x-small dark @click="closeDataSuccess()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  getDataDetail as getDataDetailOrder,
  cancelOrder as cancelDataOrder
} from '@/api/order'
export default {
  data() {
    return {
      dialog: {
        dialogCancelOrder: false
      },
      dataSuccess: {
        show: false,
        message: ''
      },
      distance: 0,
      timerInterval: null,
      order: {}
    }
  },
  computed: {
    formattedTimeLeft() {
      let days = Math.floor(this.distance / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.distance % (1000 * 60)) / 1000)
      let result
      if (this.distance < 0) {
        result = 'EXPIRED'
      } else {
        days = days === 0 ? '' : days + ' : '
        hours = hours < 10 ? hours === 0 ? '' : '0' + hours + ' : ' : hours + ' : '
        minutes = minutes < 10 ? '0' + minutes + ':' : minutes + ':'
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = days + hours + minutes + seconds
      }
      return result
    }
  },
  beforeDestroy() {
    clearInterval(this.timerOrderInterval)
  },
  sockets: {
    connect: function() {
      console.log('socket connected')
    },
    admin_pusher_status(data) {
      var success = 'netzme_' + this.order.id + '_status = success'
      var error = 'netzme_' + this.order.id + '_status = error'
      if (!this.$isEmpty(this.order.payment_log) && this.order.payment_log.payment_source === 'ASTRAPAY-QRIS') {
        success = 'astra_' + this.order.id + '_status = success'
        error = 'astra_' + this.order.id + '_status = error'
      }
      if (data.title === success) {
        this.$store.dispatch('remove_order')
        if (this.$store.state.selected_type === 'RESERVATION') {
          this.$store.dispatch('removeDataCartReservation')
        } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
          this.$store.dispatch('removeDataCartTakeAway')
        } else if (this.$store.state.selected_type === 'DELIVERY') {
          this.$store.dispatch('removeDataCartDelivery')
        } else if (this.$store.state.selected_type === 'DINE-IN') {
          this.$store.dispatch('removeDataCartDineIn')
        }
        this.$router.push({ name: 'order', params: { id: this.order.id }}).catch(() => {})
      } else if (data.title === error) {
        this.$store.dispatch('remove_order')
        this.$router.push({ name: 'order_payment_failed' }).catch(() => {})
      }
    },
    customEmit: function(data) {
      console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order'))) {
      this.order = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order'))
      if (!this.$isEmpty(this.order.payment_log) && this.order.payment_log.expired_at) {
        this.getExpiryTime(this.order.payment_log.expired_at)
      }
      if (this.order.is_paid) {
        clearInterval(this.timerOrderInterval)
        this.$router.push({ name: 'order', params: { id: this.order.id }}).catch(() => {})
      }
    } else {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    }
  },
  methods: {
    async checkStatusPayment() {
      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        const { data } = await getDataDetailOrder(this.order.id, params)
        this.$store.state.loading_axios = false
        this.order = data.data
        if (!this.$isEmpty(this.order.payment_log) && this.order.payment_log.expired_at) {
          this.getExpiryTime(this.order.payment_log.expired_at)
        }
        if (this.order.is_paid) {
          clearInterval(this.timerOrderInterval)
          this.$router.push({ name: 'order', params: { id: this.order.id }}).catch(() => {})
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    confirmCancel() {
      this.dialog.dialogCancelOrder = true
    },
    closeDataSuccess() {
      this.dataSuccess.show = false
    },
    async cancelOrder(id) {
      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        await cancelDataOrder(id, params)
        this.$store.state.loading_axios = false
        this.dataSuccess.show = true
        this.dataSuccess.message = 'Pesanan berhasil dibatalkan'
        this.dialog.dialogCancelOrder = false
        setTimeout(() => {
          const astra_outlet = this.$store.state.store_astra
          const tmii_outlet = this.$store.state.store_tmii
          const url_id = this.$store.state.url_domain

          if (tmii_outlet.indexOf(url_id) !== -1) {
            window.location.href = 'https://order.kulinertmii.id'
          } else if (astra_outlet.indexOf(url_id) !== -1) {
            window.location.href = 'https://zestloungemenaraastra.myolsera.com'
          } else {
            this.$router.push({ name: 'home' }).catch(() => {})
          }
        }, 3000)
        this.$store.dispatch('remove_order')
        if (this.$store.state.selected_type === 'RESERVATION') {
          this.$store.dispatch('removeDataCartReservation')
        } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
          this.$store.dispatch('removeDataCartTakeAway')
        } else if (this.$store.state.selected_type === 'DELIVERY') {
          this.$store.dispatch('removeDataCartDelivery')
        } else if (this.$store.state.selected_type === 'DINE-IN') {
          this.$store.dispatch('removeDataCartDineIn')
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    goHome() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
      this.$store.dispatch('remove_order')
      if (this.$store.state.selected_type === 'RESERVATION') {
        this.$store.dispatch('removeDataCartReservation')
      } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        this.$store.dispatch('removeDataCartTakeAway')
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        this.$store.dispatch('removeDataCartDelivery')
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        this.$store.dispatch('removeDataCartDineIn')
      }
    },
    goToOrder(id) {
      this.$router.push({ name: 'order', params: { id: id }}).catch(() => {})
      this.$store.dispatch('remove_order')
      if (this.$store.state.selected_type === 'RESERVATION') {
        this.$store.dispatch('removeDataCartReservation')
      } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        this.$store.dispatch('removeDataCartTakeAway')
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        this.$store.dispatch('removeDataCartDelivery')
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        this.$store.dispatch('removeDataCartDineIn')
      }
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime()
      const _this = this
      this.timerInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.distance = countDownDate - now
        if (_this.distance < 0) {
          clearInterval(_this.timerInterval)
        }
      }, 1000)
    }
  }
}
</script>
